import {LocalStorageService} from 'ngx-webstorage';
import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

@Injectable()
export class AuthClientHelper {
    isLogged: BehaviorSubject<any> = new BehaviorSubject<any>(false);
    user: BehaviorSubject<any> = new BehaviorSubject<any>(this.getUser());

    constructor(private storage: LocalStorageService) {
    }

    extendHeaders(headers) {
        const user = this.getUser();
        if (user) {
            headers.Authorization = 'Bearer ' + user.access_token;
        }
        return headers;
    }

    isGuest() {
        return null === this.getUser();
    }

    setUserStatus(val) {
        this.isLogged.next(val);
    }

    setUser(user) {
        this.user.next(user);
        this.isLogged.next(true);
        this.storage.store('user', user);
    }

    clearUser() {
        this.user.next(null);
        this.isLogged.next(false);
        this.storage.store('user', null);
    }

    getUser() {
        return this.storage.retrieve('user');
    }
}



// WEBPACK FOOTER //
// ./src/app/core/helpers/auth/auth-client.helper.ts